import moment from 'moment'
import { stringHelper } from '@tweddle-se-team/common/helpers'

const { isN } = stringHelper

export const getYears = generation => {
  const years = []
  if (generation && isN(generation.yearFrom)) {
    const yearFrom = parseInt(generation.yearFrom)
    const yearTo = isN(generation.yearTo)
      ? parseInt(generation.yearTo)
      : yearFrom > moment().year()
        ? yearFrom // case when publication has future date
        : moment().year()

    for (let y = yearTo; y >= yearFrom; y--) years.push(y)
  }
  return years
}
